module.exports = __webpack_public_path__ + "img/section2_icon3.b58f4fc8.svg";